import React, { useEffect, useState } from "react";

const subnetPrefix = "10.3.125.";
const port = 8080;
const videoPath = "/video";

const AdminLiveDashboard = () => {
  const [streams, setStreams] = useState([]);

  useEffect(() => {
    const checkStreams = async () => {
      const promises = [];
      for (let i = 1; i <= 254; i++) {
        const ip = `${subnetPrefix}${i}`;
        const url = `http://${ip}:${port}${videoPath}`;

        promises.push(
          fetch(url, { method: "HEAD" })
            .then((res) => {
              if (res.ok) {
                return ip;
              } else {
                return null;
              }
            })
            .catch(() => null)
        );
      }

      const results = await Promise.all(promises);
      const availableStreams = results.filter((ip) => ip !== null);
      setStreams(availableStreams);
    };

    checkStreams();
    const interval = setInterval(checkStreams, 15000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <h2>Admin Live Dashboard - All Screens</h2>
      {streams.length === 0 ? (
        <p>No streams available.</p>
      ) : (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
          {streams.map((ip) => (
            <div key={ip}>
              <p style={{ fontSize: 12 }}>{ip}</p>
              <img
                src={`http://${ip}:${port}${videoPath}`}
                width={300}
                height={200}
                style={{ border: "1px solid #ccc", objectFit: "cover" }}
                alt={`Live stream from ${ip}`}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminLiveDashboard;
